module.exports = __webpack_public_path__ + "img/btn_order_up.d9612c2a.svg";